/** Alnarp's Farm — delivery line is 0 kr at checkout (must match backend). */
export const CSA_FARM_PICKUP_LOCATION_ID = "6992d611eb56ff73586183c2";

export function isCsaFarmPickupLocation(pickupLocationId: string): boolean {
  return String(pickupLocationId).trim() === CSA_FARM_PICKUP_LOCATION_ID;
}

export function resolveCsaDeliveryDisplaySek(
  pickupLocationId: string,
  seasonCsaDeliveryPrice: number,
): number {
  return isCsaFarmPickupLocation(pickupLocationId) ? 0 : seasonCsaDeliveryPrice;
}

/** Signed up at the farm (no delivery fee) — location is fixed for the season. */
export function isPickupLocationLockedAtSignup(
  signupPickupLocationId?: string | null,
): boolean {
  return (
    signupPickupLocationId != null &&
    signupPickupLocationId !== "" &&
    isCsaFarmPickupLocation(signupPickupLocationId)
  );
}
